"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mail-in-a-Box
 * Mail-in-a-Box API HTTP specification.
 *
 * The version of the OpenAPI document: 0.47.0
 * Contact: contact@mailinabox.email
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var SystemApi = /** @class */ (function (_super) {
    __extends(SystemApi, _super);
    function SystemApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the system backup config.
     * Get system backup config
     */
    SystemApi.prototype.getSystemBackupConfigRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/backup/config",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.SystemBackupConfigResponseFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns the system backup config.
     * Get system backup config
     */
    SystemApi.prototype.getSystemBackupConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSystemBackupConfigRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the system backup status.  If the list of backups is empty, this implies no backups have been made yet.
     * Get system backup status
     */
    SystemApi.prototype.getSystemBackupStatusRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/backup/status",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.SystemBackupStatusResponseFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns the system backup status.  If the list of backups is empty, this implies no backups have been made yet.
     * Get system backup status
     */
    SystemApi.prototype.getSystemBackupStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSystemBackupStatusRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns system privacy (new-version check) status.  Response:    - `true`: Private, new-version checks will not be performed   - `false`: Not private, new-version checks will be performed
     * Get system privacy status
     */
    SystemApi.prototype.getSystemPrivacyStatusRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/privacy",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Returns system privacy (new-version check) status.  Response:    - `true`: Private, new-version checks will not be performed   - `false`: Not private, new-version checks will be performed
     * Get system privacy status
     */
    SystemApi.prototype.getSystemPrivacyStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSystemPrivacyStatusRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the system reboot status.  Response:    - `true`: A reboot is required   - `false`: A reboot is not required
     * Get system reboot status
     */
    SystemApi.prototype.getSystemRebootStatusRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/reboot",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Returns the system reboot status.  Response:    - `true`: A reboot is required   - `false`: A reboot is not required
     * Get system reboot status
     */
    SystemApi.prototype.getSystemRebootStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSystemRebootStatusRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns an array of statuses which can include headings.
     * Get system status
     */
    SystemApi.prototype.getSystemStatusRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/status",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return models_1.SystemStatusResponseFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * Returns an array of statuses which can include headings.
     * Get system status
     */
    SystemApi.prototype.getSystemStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSystemStatusRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns system (apt) updates.
     * Get system updates
     */
    SystemApi.prototype.getSystemUpdatesRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/updates",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Returns system (apt) updates.
     * Get system updates
     */
    SystemApi.prototype.getSystemUpdates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSystemUpdatesRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns Mail-in-a-Box upstream version.
     * Get system upstream version
     */
    SystemApi.prototype.getSystemUpstreamVersionRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/latest-upstream-version",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Returns Mail-in-a-Box upstream version.
     * Get system upstream version
     */
    SystemApi.prototype.getSystemUpstreamVersion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSystemUpstreamVersionRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns installed Mail-in-a-Box version.
     * Get system version
     */
    SystemApi.prototype.getSystemVersionRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/version",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Returns installed Mail-in-a-Box version.
     * Get system version
     */
    SystemApi.prototype.getSystemVersion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSystemVersionRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Reboots the system.
     * Reboot system
     */
    SystemApi.prototype.rebootSystemRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/reboot",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Reboots the system.
     * Reboot system
     */
    SystemApi.prototype.rebootSystem = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.rebootSystemRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the system backup config.
     * Update system backup config
     */
    SystemApi.prototype.updateSystemBackupConfigRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.target === null ||
                            requestParameters.target === undefined) {
                            throw new runtime.RequiredError('target', 'Required parameter requestParameters.target was null or undefined when calling updateSystemBackupConfig.');
                        }
                        if (requestParameters.targetUser === null ||
                            requestParameters.targetUser === undefined) {
                            throw new runtime.RequiredError('targetUser', 'Required parameter requestParameters.targetUser was null or undefined when calling updateSystemBackupConfig.');
                        }
                        if (requestParameters.targetPass === null ||
                            requestParameters.targetPass === undefined) {
                            throw new runtime.RequiredError('targetPass', 'Required parameter requestParameters.targetPass was null or undefined when calling updateSystemBackupConfig.');
                        }
                        if (requestParameters.minAge === null ||
                            requestParameters.minAge === undefined) {
                            throw new runtime.RequiredError('minAge', 'Required parameter requestParameters.minAge was null or undefined when calling updateSystemBackupConfig.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.target !== undefined) {
                            formParams.append('target', requestParameters.target);
                        }
                        if (requestParameters.targetUser !== undefined) {
                            formParams.append('target_user', requestParameters.targetUser);
                        }
                        if (requestParameters.targetPass !== undefined) {
                            formParams.append('target_pass', requestParameters.targetPass);
                        }
                        if (requestParameters.minAge !== undefined) {
                            formParams.append('min_age', requestParameters.minAge);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/backup/config",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Updates the system backup config.
     * Update system backup config
     */
    SystemApi.prototype.updateSystemBackupConfig = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSystemBackupConfigRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates system (apt) packages.
     * Update system packages
     */
    SystemApi.prototype.updateSystemPackagesRaw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/update-packages",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Updates system (apt) packages.
     * Update system packages
     */
    SystemApi.prototype.updateSystemPackages = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSystemPackagesRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates system privacy (new-version) check status.  Request:    - `value: private`: Disable new version checks   - `value: off`: Enable new version checks
     * Update system privacy
     */
    SystemApi.prototype.updateSystemPrivacyRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, consumes, canConsumeForm, formParams, useForm, response, contentType, isJson;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.value === null ||
                            requestParameters.value === undefined) {
                            throw new runtime.RequiredError('value', 'Required parameter requestParameters.value was null or undefined when calling updateSystemPrivacy.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (this.configuration &&
                            (this.configuration.username !== undefined ||
                                this.configuration.password !== undefined)) {
                            headerParameters['Authorization'] =
                                'Basic ' +
                                    btoa(this.configuration.username + ':' + this.configuration.password);
                        }
                        consumes = [
                            { contentType: 'application/x-www-form-urlencoded' },
                        ];
                        canConsumeForm = runtime.canConsumeForm(consumes);
                        useForm = false;
                        if (useForm) {
                            formParams = new FormData();
                        }
                        else {
                            formParams = new URLSearchParams();
                        }
                        if (requestParameters.value !== undefined) {
                            formParams.append('value', requestParameters.value);
                        }
                        return [4 /*yield*/, this.request({
                                path: "/system/privacy",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: formParams,
                            })];
                    case 1:
                        response = _a.sent();
                        contentType = response.headers.get('content-type');
                        isJson = contentType && contentType.includes('application/json');
                        return [2 /*return*/, new runtime[isJson ? 'JSONApiResponse' : 'TextApiResponse'](response)];
                }
            });
        });
    };
    /**
     * Updates system privacy (new-version) check status.  Request:    - `value: private`: Disable new version checks   - `value: off`: Enable new version checks
     * Update system privacy
     */
    SystemApi.prototype.updateSystemPrivacy = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateSystemPrivacyRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SystemApi;
}(runtime.BaseAPI));
exports.SystemApi = SystemApi;
